import React from 'react';
import SplashContent from './sections/SplashContent'

const Content = (props) => {
    return <div className="pt-5 mt-5"><SplashContent section={props.page} /></div>;
};

export default Content;